import Imprint from "../en/imprint";
export default Imprint;
